var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#FFD1AB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_18895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12V8.8C12 8.58783 12.0843 8.38434 12.2343 8.23431C12.3843 8.08429 12.5878 8 12.8 8H23.2C23.4122 8 23.6157 8.08429 23.7657 8.23431C23.9157 8.38434 24 8.58783 24 8.8V19.2C24 19.4122 23.9157 19.6157 23.7657 19.7657C23.6157 19.9157 23.4122 20 23.2 20H20V23.1944C20 23.6392 19.6408 24 19.1944 24H8.8056C8.69978 24.0001 8.59497 23.9793 8.49719 23.9389C8.3994 23.8984 8.31055 23.8391 8.23572 23.7643C8.16089 23.6895 8.10156 23.6006 8.06111 23.5028C8.02066 23.405 7.9999 23.3002 8 23.1944L8.0024 12.8056C8.0024 12.3608 8.3616 12 8.808 12H12ZM13.6 12H19.1944C19.6392 12 20 12.3592 20 12.8056V18.4H22.4V9.6H13.6V12ZM18.4 13.6H9.6024L9.6 22.4H18.4V13.6ZM13.2024 20.8L10.3736 17.9712L11.5048 16.84L13.2024 18.5376L16.596 15.1432L17.7272 16.2744L13.2024 20.8Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_18895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.9d6249b04c7b15ea384d139fe7157cef.svg";
export { ForwardRef as ReactComponent };